export const welcomingText = {
  header: `Bienvenue sur le <b style="color:#007E72;">formulaire interactif de création de votre Fleur de l'Agroécologie</b>, adaptée à votre ferme ou votre système alimentaire territorial.  `,
  text: `
    <p>La Fleur de l'Agroécologie de Fermes d'Avenir est un <b>outil de réflexion sur les projets agroécologiques</b>, représentant 12 défis agroécologiques essentiels auxquels l’agriculture et l’alimentation doivent répondre.</p>
     
    <p>La <b>réponse de votre système à ces défis est représentée par un ensemble de curseurs</b>, le niveau maximal de réponse correspondant à une durabilité maximale. Nous vous proposons ici de répondre à un petit formulaire de <b>12 questions</b> pour identifier votre approche sur chacun des 12 défis. Vous pourrez ensuite télécharger votre propre Fleur de l'Agroécologie, et/ou l'exporter sur votre fiche sur la cartographie des Fermes d'Avenir.</p> 
     
    `,
};

export const concludingText = {
  header: null,
  text: `
    <h2 style="color:#007E72;">Cet exercice s’adresse à différents acteurs :</h2>
     
    <p>
        <ul>
            <li>&#128105;&#127995;Les porteurs de projets qui cherchent à prioriser les objectifs de leurs futures fermes,</li>
    
            <li>&#128104;&#8205;&#127806;Les agriculteurs qui souhaitent mettre en avant le profil agroécologique de leurs fermes pour en parler de façon structurée et objective à leurs consommateurs </li>
    
            <li>&#127869;&#65039;Les acteurs des filières alimentaires qui s’interrogent sur les enjeux à adresser dans leurs approvisionnements</li>
    
            <li>&#127961;&#65039;Les collectivités qui cherchent à structurer leurs stratégies agricoles</li>
        </ul> 
    </p>`,
};
